import React, {useEffect, useState} from 'react';
import {
    Wand2,
    Image as ImageIcon,
} from 'lucide-react';
import StickerGeneratorForm from "../form/StickerGeneratorForm";
import {useRecoilValue} from "recoil";
import {channelSelector} from "../../store/selector/selector";


export default function AiStickerGenerator() {
    const channel = useRecoilValue(channelSelector)

    const [generatedImage, setGeneratedImage] = useState(null);

    return (
        <div className="min-h-screen bg-gray-50 p-8 text-gray-800 relative">
            <div className="mx-auto">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold flex items-center gap-2 text-gray-900">
                        <Wand2 className="w-8 h-8 text-blue-600" />
                        AI 스티커 제작
                    </h1>
                    <p className="text-gray-500 mt-2">스티커 옵션을 선택하고 AI를 통해 맞춤형 스티커를 생성하세요.</p>
                </div>
                <StickerGeneratorForm channelId={channel} setGeneratedImage={setGeneratedImage} />

                {/* 결과 패널 */}
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col">
                    <h2 className="text-xl font-bold mb-6 border-b pb-4">미리보기 및 결과</h2>

                    <div className={`flex-1 flex flex-col items-center justify-center rounded-xl border-2 border-dashed ${generatedImage ? 'border-transparent' : 'border-gray-200 bg-gray-50'} overflow-hidden relative min-h-[400px]`}>
                        {!generatedImage && (
                            <div className="flex flex-col items-center text-gray-400">
                                <ImageIcon className="w-16 h-16 mb-4 text-gray-300" />
                                <p>옵션을 설정하고 스티커를 생성해보세요.</p>
                            </div>
                        )}

                        {generatedImage && (
                            <img
                                src={generatedImage}
                                alt="Generated Sticker"
                                className="w-full h-full rounded-xl shadow-md"
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}